import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const HeaderAuthStyle = {
  wrapper: css`
    display: flex;
    align-items: center;
  `,

  infoHeader: () => css`
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-direction: column;

    h4 {
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `,
  groupBalance: () => css`
    display: flex;
    gap: 8px;
    .balance {
      display: flex;
      flex-direction: column;
    }

    .iconRefresh {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    @keyframes spin {
      100% {
        transform: rotate(360deg);
      }
    }

    .spin {
      animation: spin 1s linear infinite;
    }
  `,
  avatar: () => css`
    width: 50px;
    height: 50px;
    cursor: pointer;
  `,

  title: (visibleMenu: string, colorText: string) => css`
    width: 100%;
    text-align: right;
    color: ${visibleMenu ? theme.colors.lightText : colorText};
  `,

  points: (visibleMenu: string, colorText: string) => css`
    display: flex;
    align-items: center;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: ${visibleMenu ? "#2f0506" : colorText};
      white-space: nowrap;

      span {
        font-weight: 600;
        margin-left: 5px;
        color: ${theme.colors.darkGreen};
      }
    }
  `,
  turnover: (visibleMenu: string, colorText: string) => css`
    display: flex;
    flex-direction: column;
    justify-content: baseline;
    align-items: flex-start;
    margin-left: 12px;
    line-height: 1.2;
    color: ${visibleMenu ? theme.colors.lightText : colorText};

    span {
      font-weight: 400;
      text-transform: uppercase;
      font-size: 12px;
    }

    .amount {
      line-height: 1.5;
      display: flex;
      align-items: center;

      span {
        display: block;
        font-weight: 500;
        font-size: 12px;
        max-width: 70px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  `,
};
